import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const EASE = [0.22, 1, 0.36, 1];

const CARDS = [
  {
    num: "01",
    name: "De La Vie Maison",
    loc: "Baker, LA",
    specs: "4 Bedrooms + Bunk Room · 2–3 Baths · Sleeps 8+",
    anchor: "de-la-vie",
  },
  {
    num: "02",
    name: "Heritage",
    loc: "Ascension Parish, LA",
    specs: "3 Bedrooms · 7 Beds · 2 Baths · Extended Stays",
    anchor: "heritage",
  },
  {
    num: "03",
    name: "Hearthstead Cottage",
    loc: "Baker, LA",
    specs: "2 Bedrooms + Loft · 1 Bath · Sleeps 4",
    anchor: "hearthstead",
  },
];

export default function AtAGlance() {
  return (
    <section data-testid="at-a-glance" className="bg-[#fbf8f0]/90 text-[#16301f]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="flex flex-wrap items-end justify-between gap-4 mb-10"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#16301f]/60 flex items-center gap-4">
            <span className="h-px w-12 bg-[#16301f]/40 inline-block" />
            The Collection at a Glance
          </p>
          <p className="font-script text-3xl text-[#1a3324] -rotate-1">Three residences. One standard.</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-px bg-[#16301f]/10 border border-[#16301f]/10">
          {CARDS.map((c, i) => (
            <motion.button
              key={c.anchor}
              data-testid={`glance-card-${c.anchor}`}
              onClick={() => scrollToId(`#${c.anchor}`)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
              className="group bg-[#fbf8f0] hover:bg-[#f7f2e7] text-left p-8 transition-colors duration-500"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-display text-3xl text-[#16301f]/25">{c.num}</span>
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#16301f]/50">{c.loc}</span>
              </div>
              <h3 className="font-display text-2xl mt-4">{c.name}</h3>
              <p className="text-xs text-[#16301f]/60 font-light mt-2 leading-relaxed">{c.specs}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#16301f]/70 group-hover:text-[#16301f] transition-colors duration-300">
                View Residence
                <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
